// core version + navigation, pagination modules:
import Swiper from 'swiper';
import { Pagination, Autoplay } from 'swiper/modules';

export default function initHeroSlider() {
  document.querySelectorAll('.hero-slider').forEach((slider) => {
    const anchorLink = slider.querySelector('.anchor-link');
    const nextSectionId = slider.nextElementSibling?.id;
    if (nextSectionId !== '') {
      anchorLink?.setAttribute('href', `#${nextSectionId}`);
      anchorLink?.classList.add('md:inline-flex');
    }
  });

  (() => new Swiper('.gallery-intro', {
    loop: true,
    autoplay: {
      delay: 10000,
    },
    modules: [Autoplay, Pagination],
    pagination: {
      el: '.gallery-pagination',
      clickable: true,
      bulletActiveClass: 'gallery-pagination-bullet-active',
      bulletClass: 'gallery-pagination-bullet w-4.5 h-4.5 cursor-pointer bg-white border-3 border-gray-200 rounded-full transition-opacity opacity-50 hover:opacity-100',

    },
  }))();
}
